import { Commission, CommissionKostenstellenart, GetTimeFromTimestamp } from '@dave/types';
import { SelectSearchOption } from '../../dave-utils-module/select-search/components/select-search/select-search.component';
import {
    Address,
    AddressEntityPropertyNames,
    isNotNullOrUndefined,
    stringifyIfNotUndefined,
} from '../../helper/helper';
import { CommissionType } from '../graphql-types';
import { BackendDate } from '../helper/backend-frontend-conversion.helper';
import { EntityRolePermissionNameEnum } from './entity-role.entity';
import { TravelZoneEntity } from './travel-zone.entity';
import { ColorEntity, ColorEntityFromBackend, ColorEntityFromColorType } from './color.entity';
import { LedgerImportDocumentTypes } from './ledger-import.entity';
import { formatDate } from '@angular/common';
import {PartnerEntityAdditionalData} from "./partner.entity";
import { MaterialPriceHistoryUpdateTypeEnum } from './materialPriceHistory.entity';
import { CustomerStatusEnum } from './customer.entity';
// const mockSharepointFolders = [{
//     Id: "CkJiITh2bVlHT1M0d1VDRHBlWWMtVWxkT1l5d2ZoUFdIM1pQdGZUN0Z4WjdSSU0zZWlIaGpZVGhRNTFrQXRpa0FIMHESIjAxQTRNSEVBM0dZQTNXMlhETDVKQVk3SVpDWjVWTFY1NFU=",
//     NameOverride: "test",
// }]
export enum SharepointRootFolderType {
    request = 'request',
    centralProjektFiles = 'centralProjektFiles',
    constructionFiles = 'constructionFiles'
}
export const SharepointRootFolderTypeNames: Record<SharepointRootFolderType, string> = {
    [SharepointRootFolderType.request]: 'Anfrageordner',
    [SharepointRootFolderType.centralProjektFiles]: 'zentrale Projektakte',
    [SharepointRootFolderType.constructionFiles]: 'Bauakte'
}
export type SharepointRootFolder = {
    Id: string;
    Title: string;
    Type: SharepointRootFolderType,
    NameOverride?: string;
}
export interface AdditionalDataCommissionEntity {
    wizardPage?: number;
    akkord?: {
        nachlassZulage?: number;
        vorarbeiterBonus?: number;
    };
    planedWorkingHours?: number;
    sharepointRootFolders?: SharepointRootFolder[];
}

export enum KostenstellenartEnum {
    Pauschale = 'PAUSCHALE',
    Regie = 'REGIE'
}

export const KostenstellenartNames: Map<KostenstellenartEnum, string> = new Map<KostenstellenartEnum, string>([
    [KostenstellenartEnum.Pauschale, 'Pauschale'],
    [KostenstellenartEnum.Regie, 'Regie'],
]);

export const CommissionEntitygqlFields: Array<keyof CommissionType> = [
        'additionalData',
        'abgabeterminAG',
        'abgabeterminQM',
        'aktenzeichen',
        'auftragseingangDurchAuftraggeber',
        'auftragsnummer',
        'commissionTypeId',
        'personId',
        'completeBusinessVolume',
        'createdAt',
        'customerId',
        'customerName',
        'deleted',
        'description',
        'employeeId',
        'ersterBerichtErstellt',
        'id',
        'interneNummer',
        'lastDeadline',
        'partnerId',
        'schadennummer',
        'schadensdatum',
        'statusBackofficeId',
        'statusFromSVId',
        'updatedAt',
        'userId',
        'versicherungsArbeitsgebiet',
        'versicherungsbedingung',
        'versicherungsCity',
        'versicherungsDescription',
        'versicherungsMobileNumber',
        'versicherungsName',
        'versicherungsnummer',
        'versicherungsPhoneNumber',
        'versicherungsPostalCode',
        'versicherungsStreet',
        'versicherungsZusatzName',
        'automaticAccountsReceivableLedger',
        'automaticAccountsReceivableLedgerByClockIns',
        'startDate',
        'plannedStartDate',
        'endDate',
        'plannedEndDate',
        'partnerOfficeId',
        'city',
        'postalCode',
        'street',
        'country',
        'versicherungssumme',
        'freeTextField1',
        'freeTextField2',
        'freeTextField3',
        'orderNoCustomer',
        'parentId',
        'costsCompleteBusinessVolume',
        'planIds',
        'costCenter',
        'handoverDate',
        'imAssigned',
        'travelZoneId',
        'retentionPercentage',
        'warrantyRetentionPercentage',
        'partialInvoiceDiscountPeriod',
        'partialInvoiceReviewPeriod',
        'closingInvoiceDiscountPeriod',
        'closingInvoiceReviewPeriod',
        'closingInvoiceDiscountPercentage',
        'partialInvoiceDiscountPercentage',
        'closingInvoiceDuePeriod',
        'partialInvoiceDuePeriod',
        'servicePeriod',
        'serviceDate',
        'maintenanceFee',
        'imAssigned',
        'offerSubmissionDate',
        'negotiationAt',
        'departmentId',
        'kostenstellenart',
        'customerSignatureDocumentId',
        //@ts-ignore
        `color {
            red
            green
            blue
            opacity
        }`,
        ];

export class CommissionEntity implements Address, SelectSearchOption {
    public AdditionalData: AdditionalDataCommissionEntity = null;
    public static FormFieldNames: Map<keyof CommissionEntity, string> = new Map([['Auftragsnummer', 'Auftragsnr.']]);
    public static EntityPropertyNames: Map<keyof Pick<CommissionEntity,
        'TravelZoneId' |
        'AbgabeterminAG' |
        'AbgabeterminQM' |
        'LastDeadline' |
        'Auftragsnummer' |
        'CostCenter' |
        'Street' |
        'PostalCode' |
        'City' |
        'Country' |
        'AuftragseingangDurchAuftraggeber' |
        'StartDate' |
        'EndDate' |
        'Schadensdatum' |
        'Versicherungssumme' |
        'Schadennummer' |
        'Versicherungsnummer' |
        'AutomaticAccountsReceivableLedger' |
        'AutomaticAccountsReceivableLedgerByClockIns' |
        'OrderNoCustomer' |
        'CompleteBusinessVolume' |
        'CostsCompleteBusinessVolume' |
        'ServicePeriod' |
        'ServiceDate' |
        'MaintenanceFee' |
        'OfferSubmissionDate' |
        'NegotiationAt' |
        'PersonId' |
        'DepartmentId' |
        'ParentId' |
        'Kostenstellenart'
    >, string> = new Map([
        ['TravelZoneId', TravelZoneEntity.EntityName],
        ['AbgabeterminAG', 'Abgabetermin AG'],
        ['AbgabeterminQM', 'Abgabetermin QM'],
        ['LastDeadline', 'Letzte Frist'],
        // ['Description', 'Sache'],
        ['Auftragsnummer', CommissionEntity.FormFieldNames.get('Auftragsnummer')],
        ['CostCenter', 'Kostenstelle'],
        ['Street', AddressEntityPropertyNames.get('Street')],
        ['PostalCode', AddressEntityPropertyNames.get('PostalCode')],
        ['City', AddressEntityPropertyNames.get('City')],
        ['Country', AddressEntityPropertyNames.get('Country')],
        ['AuftragseingangDurchAuftraggeber', 'Auftragseingang'],
        ['StartDate', 'Startdatum'],
        ['EndDate', 'Enddatum'],
        ['Schadensdatum', 'Schadensdatum'],
        ['Versicherungssumme', 'Versicherungssumme'],
        ['Schadennummer', 'SchadenNr.'],
        ['Versicherungsnummer', 'VersicherungsNr.'],
        ['AutomaticAccountsReceivableLedger', 'Automatische Buchungspositionen'],
        ['AutomaticAccountsReceivableLedgerByClockIns', 'Automatische Buchungspositionen auf Basis der Zeiterfassungsdaten'],
        ['OrderNoCustomer', 'Bestellnummer des Kunden'],
      //  ['CompleteBusinessVolume', 'Geplanter Umsatz (Netto)'],
        ['CostsCompleteBusinessVolume', 'Geplante Kosten (Netto)'],
        ['ServicePeriod', 'Leistungszeitraum'],
        ['ServiceDate', 'Leistungsdatum'],
        ['MaintenanceFee', 'Wartungspauschale'],
        ['OfferSubmissionDate', 'Angebotsabgabe'],
        ['NegotiationAt', 'Verhandlung am'],
        ['PersonId', 'Anfragekontakt'],
        ['DepartmentId', 'Leitungssparte'],
        ['ParentId', 'Groß-/ Projekte'],
        ['Kostenstellenart', 'Kostenstellenart'],
    ]);

    constructor(
        public Id: number = null,
        public Description: string = '', // sache
        public CommissionTypeId: number = null,
        public Schadensdatum: Date = null,
        public Versicherungsbedingung: string = '',
        public InterneNummer: string = '',
        public Auftragsnummer: string = '',
        public Aktenzeichen: string = '',
        public VersicherungsName: string = '',
        public VersicherungsDescription = '',
        public VersicherungsZusatzName = '',
        public VersicherungsCity = '',
        public VersicherungsStreet = '',
        public VersicherungsPostalCode = '',
        public VersicherungsMobileNumber = '',
        public VersicherungsPhoneNumber = '',
        public VersicherungsArbeitsgebiet = '',
        public Schadennummer: string = '',
        public Versicherungsnummer: string = '',
        public CustomerName: string = '',
        public AuftragseingangDurchAuftraggeber: Date = null,
        public AbgabeterminAG: Date = null,
        public AbgabeterminQM: Date = null,
        public StatusfromSVId: number = null,
        public StatusBackofficeId: number = null,
        public LastDeadline: Date = null,
        public CustomerId: number = null,
        public EmployeeId: number = null,
        public UserId: number = null,
        public PersonId: number = null,
        public PartnerId: number = null,
        public Deleted: boolean = false,
        public CreatedAt: Date = null,
        public UpdatedAt: Date = null,
        public AutomaticAccountsReceivableLedger: number = null,
        public AutomaticAccountsReceivableLedgerByClockIns: number = null,
        public PlannedStartDate: Date = null,
        public StartDate: Date = null,
        public PlannedEndDate: Date = null,
        public EndDate: Date = null,
        public PartnerOfficeId: number = null,
        public City: string = null,
        public PostalCode: string = null,
        public Street: string = null,
        public Country: string = null,
        AdditionalDataInput: string = null,
        public Versicherungssumme: string = '',
        public FreeTextField1: string = null,
        public FreeTextField2: string = null,
        public FreeTextField3: string = null,
        public OrderNoCustomer: string = null,
        public CompleteBusinessVolume: number = null,
        public ParentId: number = null,
        public CostsCompleteBusinessVolume: number = null,
        public PlanIds: number[] = null,
        public CostCenter: string = null,
        public HandoverDate: Date = null,
        public ImAssigned: boolean = null,
        public TravelZoneId: number = null,

        public RetentionPercentage: number | null = null,
        public WarrantyRetentionPercentage: number | null = null,
        public PartialInvoiceDiscountPeriod: number | null = null,
        public PartialInvoiceReviewPeriod: number | null = null,
        public ClosingInvoiceDiscountPeriod: number | null = null,
        public ClosingInvoiceReviewPeriod: number | null = null,
        public ClosingInvoiceDiscountPercentage: number | null = null,
        public PartialInvoiceDiscountPercentage: number | null = null,
        public ClosingInvoiceDuePeriod: number | null = null, // float
        public PartialInvoiceDuePeriod: number | null = null, // float
        public ServicePeriod: string = null,
        public ServiceDate: Date = null,
        public MaintenanceFee: number | null = null, // float
        public Color: ColorEntity = null,
        public OfferSubmissionDate: Date = null,
        public NegotiationAt: Date = null,
        public DepartmentId: number = null,
        // public SharepointRootFolders: SharepointRootFolder[] | null = null,
        private commissionDisplayNameCostCenter: boolean = false,
        public Kostenstellenart: KostenstellenartEnum = null,
        public CustomerSignatureDocumentId: number | null = null,
    ) {
        if (AdditionalDataInput != '') {
            try {
                this.AdditionalData = JSON.parse(AdditionalDataInput);
            } catch (e) {
                console.log(AdditionalDataInput)
                throw 'broken Json in additionaldata, commissionId: ' + Id;
            }
        }
    }
    get SharepointRootFolders() {
        return this.AdditionalData?.sharepointRootFolders || [];
    }
    public GetBackgroundColor(isCompleted: boolean, color: string, opacity = 20) {
        if (!color) {
            return '#00000000';
        }
        let toHex = parseInt(opacity + '', 16);
        if (toHex > 255) {
            toHex = 255;
        }
        const hexOpacity = toHex.toString(16);
        let ret = !isCompleted && this.LastDeadline && this.LastDeadline <= new Date() ? '#ff0000' : color;
        return ret.slice(0, 7) + hexOpacity;
    }
    public Clone(override: Partial<CommissionEntity> = {}): CommissionEntity {
        const attr = { ...this, ...override };
        return Object.assign(new CommissionEntity(), attr);
    }

    getSkontoPeriodForLedgerImports(documentType: LedgerImportDocumentTypes) {
        switch (documentType) {
            case LedgerImportDocumentTypes.Invoice:
            case LedgerImportDocumentTypes.ClosingInvoice:
                return this.ClosingInvoiceDiscountPeriod;
            case LedgerImportDocumentTypes.PartialInvoice:
                return this.PartialInvoiceDiscountPeriod;
            default:
                return null;
        }
    }

    getSkontoForLedgerImports(documentType: LedgerImportDocumentTypes) {
        switch (documentType) {
            case LedgerImportDocumentTypes.Invoice:
            case LedgerImportDocumentTypes.ClosingInvoice:
                return this.ClosingInvoiceDiscountPercentage;
            case LedgerImportDocumentTypes.PartialInvoice:
                return this.PartialInvoiceDiscountPercentage;
            default:
                return null;
        }
    }



    public GetDisplayName() {
        let name = this.Auftragsnummer ? this.Auftragsnummer : '';
        if (this.commissionDisplayNameCostCenter) {
            name = name && this.CostCenter ? name + ', ' : name;
            name = this.CostCenter ? name + this.CostCenter : name;
        } else {
            name = name && this.InterneNummer ? name + ', ' : name;
            name = this.InterneNummer ? name + this.InterneNummer : name;
        }
        name = name && this.Description ? name + ', ' : name;
        name = this.Description ? name + this.Description : name;
        name = name && this.Schadennummer ? name + ', ' : name;
        name = this.Schadennummer ? name + this.Schadennummer : name;

        return name ? name : 'unbenannt';
    }
    public GetDisplayNameShiftPlan() {
        let name = this.Description ? this.Description : '';
        name = name && this.Auftragsnummer ? name + ', ' : name;
        name = this.Auftragsnummer ? name + this.Auftragsnummer : name;
        if (this.commissionDisplayNameCostCenter) {
            name = name && this.CostCenter ? name + ', ' : name;
            name = this.CostCenter ? name + this.CostCenter : name;
        } else {
            name = name && this.InterneNummer ? name + ', ' : name;
            name = this.InterneNummer ? name + this.InterneNummer : name;
        }
        name = name && this.Schadennummer ? name + ', ' : name;
        name = this.Schadennummer ? name + this.Schadennummer : name;

        return name ? name : 'unbenannt';
    }

    public optionLableWizardDialog(partnerOfficeName: string, editor: string, departmentName: string){

        let name = this.Description ? this.Description : '';
        name = name && this.Auftragsnummer ? name + ', ' : name;
        name = this.Auftragsnummer ? name + this.Auftragsnummer : name;
        name = name && partnerOfficeName ? name + ', ' : name
        name = partnerOfficeName ? name + partnerOfficeName : name;

        name = name && this.CreatedAt ? name + ', ' : name
        name = this.CreatedAt ? name + formatDate(this.CreatedAt, 'dd.MM.yyyy', 'de')  : name;


        name = name && editor ? name + ', ' : name
        name = editor ? name + editor : name;

        name = name && departmentName ? name + ', ' : name;
        name = departmentName ? name + departmentName : name;

        name = name && this.Street ? name + ', ' : name;
        name = this.Street ? name + this.Street : name;

        name = name && this.PostalCode ? name + ', ' : name;
        name = this.PostalCode ? name + this.PostalCode : name;

        name = name && this.City ? name + ', ' : name;
        name = this.City ? name + this.City : name;



        return name ? name : 'unbenannt';
    }

    get DisplayName() {
        return `${this.Auftragsnummer ? this.Auftragsnummer : '--'} | ${this.Description ? this.Description : '--'} | ${this.commissionDisplayNameCostCenter ? (this.CostCenter ? this.CostCenter : '--') : (this.InterneNummer ? this.InterneNummer : '--')}`;
    }
    get optionLabel() {
        return this.CustomerName ? [this.DisplayName, this.CustomerName].join(', ') : this.DisplayName;
    }
    get optionSearch() {
        return [this.InterneNummer, this.Description, this.Auftragsnummer, this.CustomerName].filter((v) => v).map((v) => v.trim().toLowerCase());
    }
    get optionLabelReverse() {
        return this.CustomerName ? [this.CustomerName, this.DisplayName].join(', ') : this.DisplayName;
    }
    get chipLabel() {
        return this.DisplayName;
    }
    permissionGet(prop: keyof CommissionEntity | keyof AdditionalDataCommissionEntity, EntityRoles: Array<{ Permissions: Array<{ name: EntityRolePermissionNameEnum }> }>): boolean {
        switch (prop) {
            case 'CompleteBusinessVolume':
                return EntityRoles.some((e) => e.Permissions.some((p) => p.name === EntityRolePermissionNameEnum.GetCompleteBusinessVolume));

            case 'CostsCompleteBusinessVolume':
                return EntityRoles.some((e) => e.Permissions.some((p) => p.name === EntityRolePermissionNameEnum.GetCostsCompleteBusinessVolume));

            case 'Versicherungssumme':
                return EntityRoles.some((e) => e.Permissions.some((p) => p.name === EntityRolePermissionNameEnum.GetVersicherungssumme));

            case 'planedWorkingHours':
                return EntityRoles.some((e) => e.Permissions.some((p) => p.name === EntityRolePermissionNameEnum.GetPlanedWorkingHours));
            default:
                return true;
        }
    }
}

export function CommissionEntityFromGRPCBackend(res: Commission, commissionDisplayNameCostCenter: boolean): CommissionEntity {
    const kostenstellenartValue: KostenstellenartEnum | null = (() => {
        switch (res.Kostenstellenart) {
            case CommissionKostenstellenart.Pauschale:
                return KostenstellenartEnum.Pauschale;

            case CommissionKostenstellenart.Regie:
                return KostenstellenartEnum.Regie;

            default:
                return null;
        }
    })();

    return new CommissionEntity(
        +res.Id,
        res.Description,
        res.CommissionTypeId ? +res.CommissionTypeId : null,
        res.Schadensdatum ? GetTimeFromTimestamp(+res.Schadensdatum) : null,
        res.Versicherungsbedingung,
        res.InterneNummer,
        res.Auftragsnummer,
        res.Aktenzeichen,
        res.VersicherungsName,
        res.VersicherungsDescription,
        res.VersicherungsZusatzName,
        res.VersicherungsCity,
        res.VersicherungsStreet,
        res.VersicherungsPostalCode,
        res.VersicherungsMobileNumber,
        res.VersicherungsPhoneNumber,
        res.VersicherungsArbeitsgebiet,
        res.Schadennummer,
        res.Versicherungsnummer,
        res.CustomerName,
        res.AuftragseingangDurchAuftraggeber ? GetTimeFromTimestamp(+res.AuftragseingangDurchAuftraggeber) : null,
        res.AbgabeterminAG ? GetTimeFromTimestamp(+res.AbgabeterminAG) : null,
        res.AbgabeterminQM ? GetTimeFromTimestamp(+res.AbgabeterminQM) : null,
        res.StatusFromSVId ? +res.StatusFromSVId : null,
        res.StatusBackofficeId ? +res.StatusBackofficeId : null,
        res.LastDeadline ? GetTimeFromTimestamp(+res.LastDeadline) : null,
        res.CustomerId ? +res.CustomerId : null,
        res.EmployeeId ? +res.EmployeeId : null,
        res.UserId ? +res.UserId : null,
        res.PersonId ? +res.PersonId : null,
        res.PartnerId ? +res.PartnerId : null,
        res.Deleted ?? false,
        res.CreatedAt ? GetTimeFromTimestamp(+res.CreatedAt) : null,
        res.UpdatedAt ? GetTimeFromTimestamp(+res.UpdatedAt) : null,
        res.AutomaticAccountsReceivableLedger,
        res.AutomaticAccountsReceivableLedgerByClockIns,
        res.PlannedStartDate ? GetTimeFromTimestamp(+res.PlannedStartDate) : null,
        res.StartDate ? GetTimeFromTimestamp(+res.StartDate) : null,
        res.PlannedEndDate ? GetTimeFromTimestamp(+res.PlannedEndDate) : null,
        res.EndDate ? GetTimeFromTimestamp(+res.EndDate) : null,
        res.PartnerOfficeId ? +res.PartnerOfficeId : null,
        res.City,
        res.PostalCode,
        res.Street,
        res.Country,
        res.AdditionalData,
        res.Versicherungssumme,
        res.FreeTextField1,
        res.FreeTextField2,
        res.FreeTextField3,
        res.OrderNoCustomer,
        isNotNullOrUndefined(res.CompleteBusinessVolume) ? res.CompleteBusinessVolume : null,
        res.ParentId ? +res.ParentId : null,
        isNotNullOrUndefined(res.CostsCompleteBusinessVolume) ? res.CostsCompleteBusinessVolume : null,
        res.PlanIds ? res.PlanIds.map((id) => +id) : [],
        res.CostCenter,
        res.HandoverDate ? GetTimeFromTimestamp(+res.HandoverDate) : null,
        res.ImAssigned,
        res.TravelZoneId ? +res.TravelZoneId : null,
        res.RetentionPercentage,
        res.WarrantyRetentionPercentage,
        res.PartialInvoiceDiscountPeriod,
        res.PartialInvoiceReviewPeriod,
        res.ClosingInvoiceDiscountPeriod,
        res.ClosingInvoiceReviewPeriod,
        res.ClosingInvoiceDiscountPercentage,
        res.PartialInvoiceDiscountPercentage,
        res.ClosingInvoiceDuePeriod,
        res.PartialInvoiceDuePeriod,
        res.ServicePeriod,
        res.ServiceDate ? GetTimeFromTimestamp(+res.ServiceDate) : null,
        res.MaintenanceFee,
        res.Color ? ColorEntityFromColorType(res.Color) : null,
        res.OfferSubmissionDate ? GetTimeFromTimestamp(+res.OfferSubmissionDate) : null,
        res.NegotiationAt ? GetTimeFromTimestamp(+res.NegotiationAt) : null,
        res.DepartmentId ? +res.DepartmentId : null,
        commissionDisplayNameCostCenter,
        kostenstellenartValue,
        res.CustomerSignatureDocumentId ? +res.CustomerSignatureDocumentId : null,
    );
}

export function CommissionEntityFromBackend(res: CommissionType, commissionDisplayNameCostCenter: boolean): CommissionEntity {


    return new CommissionEntity(
        res.id,
        res.description,
        res.commissionTypeId,
        res.schadensdatum && BackendDate(res.schadensdatum),
        res.versicherungsbedingung,
        res.interneNummer,
        res.auftragsnummer,
        res.aktenzeichen,
        res.versicherungsName,
        res.versicherungsDescription,
        res.versicherungsZusatzName,
        res.versicherungsCity,
        res.versicherungsStreet,
        res.versicherungsPostalCode,
        res.versicherungsMobileNumber,
        res.versicherungsPhoneNumber,
        res.versicherungsArbeitsgebiet,
        res.schadennummer,
        res.versicherungsnummer,
        res.customerName,
        res.auftragseingangDurchAuftraggeber ? BackendDate(res.auftragseingangDurchAuftraggeber) : null,
        res.abgabeterminAG ? BackendDate(res.abgabeterminAG) : null,
        res.abgabeterminQM ? BackendDate(res.abgabeterminQM) : null,
        res.statusFromSVId,
        res.statusBackofficeId,
        res.lastDeadline ? BackendDate(res.lastDeadline) : null,
        res.customerId,
        res.employeeId,
        res.userId,
        res.personId,
        res.partnerId,
        res.deleted,
        res.createdAt ? BackendDate(res.createdAt) : null,
        res.updatedAt ? BackendDate(res.updatedAt) : null,
        res.automaticAccountsReceivableLedger,
        res.automaticAccountsReceivableLedgerByClockIns,
        // users,
        // assignedUsers,
        res.plannedStartDate ? BackendDate(res.plannedStartDate) : null,
        res.startDate ? BackendDate(res.startDate) : null,
        res.plannedEndDate ? BackendDate(res.plannedEndDate) : null,
        res.endDate ? BackendDate(res.endDate) : null,
        res.partnerOfficeId,
        res.city,
        res.postalCode,
        res.street,
        res.country,
        res.additionalData,
        res.versicherungssumme,
        res.freeTextField1,
        res.freeTextField2,
        res.freeTextField3,
        res.orderNoCustomer,
        res.completeBusinessVolume,
        res.parentId,
        res.costsCompleteBusinessVolume,
        res.planIds || [],
        res.costCenter,
        res.handoverDate ? BackendDate(res.handoverDate) : null,
        res.imAssigned,
        res.travelZoneId,
        res.retentionPercentage,
        res.warrantyRetentionPercentage,
        res.partialInvoiceDiscountPeriod,
        res.partialInvoiceReviewPeriod,
        res.closingInvoiceDiscountPeriod,
        res.closingInvoiceReviewPeriod,
        res.closingInvoiceDiscountPercentage,
        res.partialInvoiceDiscountPercentage,
        res.closingInvoiceDuePeriod,
        res.partialInvoiceDuePeriod,
        res.servicePeriod,
        res.serviceDate ? BackendDate(res.serviceDate) : null,
        res.maintenanceFee,
        res.color ? ColorEntityFromBackend(res.color) : null,
        res.offerSubmissionDate ? BackendDate(res.offerSubmissionDate) : null,
        res.negotiationAt ? BackendDate(res.negotiationAt) : null,
        res.departmentId,
        commissionDisplayNameCostCenter,
        res.kostenstellenart,
        res.customerSignatureDocumentId,
    );
}
